/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import styled from 'styled-components'
import { Label } from 'reactstrap'

const LabelCustom = styled(Label)`
  font-size: 20px;
  font-weight: normal;
  margin-bottom: 7px;
  padding-top: 5px;
  padding-bottom: 6px;
  display: block;
  width: 100%;
  line-height: 23px;
`

export default function Btn({ children, ...props }) {
  return (
    <>
      <LabelCustom {...props}>{children}</LabelCustom>
    </>
  )
}
